import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BackboneAdapterService } from '../../shared/backbone-adapter.service';
import { GTMService } from '../../shared/gtm.service';
import { NotificationService } from '../../shared/notification.service';
import { LiveClassDto } from '../../shared/types/LiveClassDto';
import { LiveClassTileInputData } from '../../shared/types/LiveClassTileInputData';
import { LiveClassEventService } from '../live-class-event.service';
import { FutureClassTile } from '../live-class-section/class-tile/future-class-tile';
import { LiveClassTile } from '../live-class-section/class-tile/live-class-tile';
import { LiveClassService } from '../live-class.service';
import { OneSignalService } from '../../shared/one-signal.service';

@Component({
  selector: 'lp2-live-class-tile',
  templateUrl: './live-class-tile.component.html',
})
export class LiveClassTileComponent implements OnInit, OnDestroy {
  @Input() liveClass: LiveClassDto = <LiveClassDto>{};
  @Input() isFutureClass: boolean;
  @Input() isCompact: boolean;

  public imgHeight: number;

  public liveClassTile: LiveClassTile | FutureClassTile;

  constructor(
    private liveClassService: LiveClassService,
    private liveClassEventService: LiveClassEventService,
    private notificationService: NotificationService,
    private backbone: BackboneAdapterService,
    private gtmService: GTMService,
    private oneSignalService: OneSignalService
  ) {}

  ngOnInit() {
    this.imgHeight = this.isCompact ? 8 : 12;
    if (this.isFutureClass) {
      this.liveClassTile = new FutureClassTile('legacy', this.liveClass);
    } else {
      this.liveClassTile = new LiveClassTile(
        this.liveClassService,
        this.liveClassEventService,
        this.notificationService,
        this.backbone,
        this.gtmService,
        this.oneSignalService,
        'legacy',
        this.liveClass
      );
    }
  }

  ngOnDestroy() {
    this.liveClassTile.destroy();
  }

  public get lockedTextKey(): string {
    return this.liveClassTile.lockedTextKey;
  }

  public get isLocked(): boolean {
    return this.liveClassTile.currentState === 'LOCKED';
  }

  public get tileData(): LiveClassTileInputData {
    return this.liveClassTile.tileData;
  }

  get buttonDisabled(): boolean {
    return this.liveClassTile.buttonDisabled;
  }

  onClose(event): void {
    // Uggly, really uggly, maybe it can be fixed when Legacy PC is removed
    if (this.liveClassTile instanceof LiveClassTile) {
      this.liveClassTile.onCancel(event);
    }
  }

  onShowDocumentClick(event: PointerEvent) {
    this.liveClassTile.onShowDocumentClick(event);
  }

  onTileClick(): void {
    this.liveClassTile.onTileClick();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-tile/live-class-tile.component.ts